import { useQuery } from '@tanstack/react-query';
import { Dispatch } from 'redux';

import { requestHandler } from '../../api';

export const getDataHubReport = (
  dispatch: Dispatch,
  businessIdentifier?: string,
  query?: string,
) =>
  useQuery({
    queryKey: [
      'reports',
      'datahub',
      businessIdentifier,
      ...(query ? [query] : []),
    ],
    queryFn: async (): Promise<Blob | undefined> => {
      const queryString = query ? `?${query}` : '';
      const response = await requestHandler({
        method: 'get',
        url: `internal/pdf/dataHubReport/${businessIdentifier}${queryString}`,
        dispatch,
        responseType: 'blob',
      });
      if (response) return response.data;
      return undefined;
    },
    retry: 1,
    enabled: false,
  });

export const getMultiverseReport = (
  dispatch: Dispatch,
  businessIdentifier?: string,
  fundIdentifier?: string,
  query?: string,
) =>
  useQuery({
    queryKey: [
      'reports',
      'multiverse',
      businessIdentifier,
      fundIdentifier,
      ...(query ? [query] : []),
    ],
    queryFn: async (): Promise<Blob | undefined> => {
      const queryString = query ? `?${query}` : '';
      const response = await requestHandler({
        method: 'get',
        url: `internal/pdf/multiverseReport/business/${businessIdentifier}/fund/${fundIdentifier}${queryString}`,
        dispatch,
        responseType: 'blob',
      });
      if (response) return response.data;
      return undefined;
    },
    retry: 1,
    enabled: false,
  });

export const getCreditLineReport = (
  dispatch: Dispatch,
  id?: number,
  query?: string,
) =>
  useQuery({
    queryKey: ['reports', 'creditLine', id, ...(query ? [query] : [])],
    queryFn: async (): Promise<Blob | undefined> => {
      const queryString = query ? `?${query}` : '';
      const response = await requestHandler({
        method: 'get',
        url: `internal/pdf/creditLine/${id}${queryString}`,
        dispatch,
        responseType: 'blob',
      });
      if (response) return response.data;
      return undefined;
    },
    retry: 1,
    enabled: false,
  });

export const getDataHubReportForFund = (
  dispatch: Dispatch,
  businessIdentifier?: string,
  companyId?: number,
  fundIdentifier?: string,
  query?: string,
) =>
  useQuery({
    queryKey: [
      'reports',
      'datahubForFund',
      businessIdentifier,
      fundIdentifier,
      ...(query ? [query] : []),
    ],
    queryFn: async (): Promise<Blob | undefined> => {
      const queryString = query ? `?${query}` : '';
      const response = await requestHandler({
        method: 'get',
        url: `internal/pdf/dataHubReportForFund/company/${companyId}/business/${businessIdentifier}${queryString}`,
        dispatch,
        responseType: 'blob',
      });
      if (response) return response.data;
      return undefined;
    },
    retry: 1,
    enabled: false,
  });
